<script>
const result = [
  // http://t.zoukankan.com/cs-whut-p-11001610.html
  { result: 0, zh: '所有结果', en: '', color: '' },
  { result: 1000, zh: '答案正确', en: 'Accepted', color: 'green' },
  { result: 1001, zh: '答案错误', en: 'Wrong Answer', color: 'red' },
  { result: 1002, zh: '格式错误', en: 'Presentation Error', color: 'red' },
  { result: 1003, zh: '时间超限', en: 'Time Limit Exceeded', color: 'red' },
  { result: 1004, zh: '内存超限', en: 'Memory Limit Exceeded', color: 'red' },
  { result: 1005, zh: '输出超限', en: 'Output Limit Exceeded', color: 'red' },
  { result: 1006, zh: '编译错误', en: 'Compile Error', color: 'red' },
  { result: 1007, zh: '运行错误', en: 'Runtime Error', color: 'red' },
  { result: 1008, zh: '编译ing', en: 'Compileing', color: 'black' },
  { result: 1009, zh: '等待ing', en: 'Waiting', color: 'black' },
  { result: 1010, zh: '重判ing', en: 'ReJudgeing', color: 'black' },
  { result: 1011, zh: '运行ing', en: 'Judgeing', color: 'black' },
  { result: 1012, zh: '暂无数据', en: 'System Error', color: 'red' },
]

const languages = [
  { value: '', option: '', label: '', language: 0, zh: '所有语言', value: 0, md: '' },
  { value: 'x-csrc', option: 'x-csrc', label: 'C', language: 1, zh: 'C 语言', value: 2, md: 'c' },
  { value: 'x-c++src', option: 'x-c++src', label: 'C++ (14)', language: 2, zh: 'C++ 语言', value: 4, md: 'cpp' },
  { value: 'x-python', option: 'x-python', label: 'Python (3.6)', language: 3, zh: 'Python 语言', value: 8, md: 'python' },
  { value: 'x-go', option: 'x-go', label: 'Go', language: 4, zh: 'Go 语言', value: 16, md: 'go' },
  { value: 'x-java', option: 'x-java', label: 'Java (17)', language: 5, zh: 'Java 语言', value: 32, md: 'java' },
  { value: 'x-python', option: 'x-python', label: 'Python Turtle', language: 6, zh: 'Python Turtle 语言', value: 64, md: 'python' },
  { value: 'x-c++src', option: 'x-c++src', label: 'GoC', language: 7, zh: 'GoC 语言', value: 128, md: 'cpp' },
  { value: 'x-c++src', option: 'x-c++src', label: 'C++ (不开o2)', language: 8, zh: 'C++ 语言', value: 256, md: 'cpp' },

  // { value: 'x-csrcnoi', option: 'x-csrc', label: 'C (NOI)', language: 5 },
  // // { value: 'x-c++src',option:'x-csrc11', label: 'C++ (11)', language: 4 },
  // { value: 'x-c++src', option: 'x-c++src', label: 'C++ (14)', language: 3 },
  // { value: 'x-c++srcnoi', option: 'x-c++src', label: 'C++ (NOI)', language: 2 },
  // { value: 'x-python', option: 'x-python', label: 'python (3.7)', language: 6 },
  // // { value: 'x-p', label: 'python (2.7)', language: 7 },
  // { value: 'x-go', option: 'x-go', label: 'Go', language: 8 },
  // { value: 'x-java', option: 'x-java', label: 'Java', language: 9 },
]

const diff = [
  { value: 0, label: '暂无评定', color: '', type: 'info' },
  { value: 1, label: '入门', color: '', type: 'danger' },

  { value: 2, label: '普及-', color: 'rgb(244, 179, 92)', type: '' },
  { value: 3, label: '普及/提高-', color: '', type: 'warning' },

  { value: 4, label: '普及+/提高', color: '', type: 'success' },  // 4
  { value: 5, label: '普及+/提高', color: '', type: 'success' },  // 4
  { value: 6, label: '提高+/省选-', color: '', type: '' },  // 6
  { value: 7, label: '提高+/省选-', color: '', type: '' },  // 6

  { value: 8, label: '省选/NOI-', color: 'rgb(146,54,201)', type: '' },
  { value: 9, label: 'NOI/NOI+', color: 'rgb(13,17,86)', type: '' },

  // { value: 2, label: '普及T1', color: '', type: 'warning' },
  // { value: 3, label: '普及T2', color: '', type: 'warning' },
  // { value: 4, label: '普及T3/提高T1', color: '', type: 'success' },
  // { value: 5, label: '普及T4/提高T1+', color: '', type: 'success' },
  // { value: 6, label: '提高T2', color: '', type: '' },
  // { value: 7, label: '提高T3', color: '', type: '' },
  // { value: 8, label: '提高T4/省选', color: 'rgb(146,54,201)', type: '' },
  // { value: 9, label: 'NOI/IOI', color: 'rgb(146,54,201)', type: '' },
]

// const subjectType = [
//   '填空测试', // 1   subjectType 1
//   '单选测试', // 2   subjectType 1
//   '多选测试', // 3   subjectType 1
//   '判断测试', // 4   subjectType 1

//   '编程测试', // 5   subjectType 2
//   '伴随学习', // 6   subjectType 3
//   '知识精讲', // 7   subjectType 4

//   '简答测试', // 8   subjectType 5
//   '问答测试', // 9   subjectType 6
//   '录播课程', // 10  subjectType 7
//   '直播课程', // 11  subjectType 8
// ]

const subjectType = [
  '填空测试', // 1   subjectType 1
  '单选测试', // 2   subjectType 1
  '多选测试', // 3   subjectType 1
  '判断测试', // 4   subjectType 1

  '程序设计', // 5   subjectType 2
  '伴随学习', // 6   subjectType 3
  'PDF', // 7   subjectType 4

  'PPT课程', // 8   subjectType 5
  'Scratch', // 9   subjectType 6
  '录播课程', // 10  subjectType 7
  'Scratch', // 11   subjectType 8
  '录播课程', // 12  subjectType 9
  'ScratchJR', // 13  subjectType 10
  'PPTX', // 14  subjectType 11
  '超链接', // 15  subjectType 11
  '终端', // 15  subjectType 11
]

const defaultSubjectType = 2 // choice

const baseProblemSubjectType = 1
const codeSubjectType = 2
const accompanySubjectType = 3
const pdfSubjectType = 4
const pptSubjectType = 5
const scratchSubjectTypeX = 6
const mp4SubjectTypeX = 7
const scratchSubjectType = 8
const mp4SubjectType = 9
const scratchJRSubjectType = 10
const pptxSubjectType = 11
const iframeSubjectType = 12
const terminalSubjectType = 13

const fill = 1
const choice = 2
const multipleChoice = 3
const judge = 4

const code = 5
const accompany = 6
const pdf = 7
const ppt = 8
const scratchX = 9
const mp4X = 10
const scratch = 11
const mp4 = 12
const scratchJR = 13
const pptx = 14
const iframe = 15
const terminal = 16

// role
// const student = 1
const student = 2
const teach = 4
const headmaster = 8
const master = 16

// OJ
const codeTheme = [
  // https://blog.csdn.net/qq_41694291/article/details/106429772
  '', 'eclipse', 'dracula', 'erlang-dark'
]
const codeThemeSelect = [
  { value: 1, label: '亮色配色' },
  { value: 2, label: '暗色配色' }
]
const fontSize = [{
  value: 12,
  label: '12 px'
}, {
  value: 16,
  label: '16 px'
}, {
  value: 20,
  label: '20 px'
}, {
  value: 24,
  label: '24 px'
}, {
  value: 28,
  label: '28 px'
}, {
  value: 32,
  label: '32 px'
}]
const tabSize = [{
  value: 2,
  label: '2个空格'
}, {
  value: 4,
  label: '4个空格'
}, {
  value: 8,
  label: '8个空格'
}]

// organization base data
// const logo = 'https://www.onlinegit.com/static/upload/img/2022/03/ae1401a9-56b4-43ae-b263-d7846cbc0c6300002.jpg'
const logo = 'https://www.onlinegit.com/static/upload/img/2022/05/15cdb418-0652-4939-be1a-ee5b6418df7e00002.png'
const loginBg = 'https://www.onlinegit.com/upload/img/2022/01/1cb62449-7ca5-4a05-95ed-cbe73ee42f0c00002..jpg'
// const organizationName = '星光科技'
const organizationName = '算法编程设计'

export default {
  // role
  student,
  teach,
  headmaster,
  master,

  diff,

  result,
  languages,

  subjectType,
  defaultSubjectType,
  baseProblemSubjectType,
  codeSubjectType,
  accompanySubjectType,
  pdfSubjectType,
  pptSubjectType,
  scratchSubjectTypeX,
  mp4SubjectTypeX,
  scratchSubjectType,
  mp4SubjectType,
  scratchJRSubjectType,
  pptxSubjectType,
  iframeSubjectType,
  terminalSubjectType,

  fill,
  choice,
  multipleChoice,
  judge,
  code,
  accompany,
  pdf,
  ppt,
  scratchX,
  mp4X,
  scratch,
  mp4,
  scratchJR,
  pptx,
  iframe,
  terminal,

  // OJ
  codeTheme,
  codeThemeSelect,
  fontSize,
  tabSize,

  // organization base data
  logo,
  organizationName,
  loginBg
}

</script>

// global 的使用
// https://www.cnblogs.com/kewenxin/p/8619240.html
// import global from '@/views/common/global.vue'
